import { render } from "./BancaOre.vue?vue&type=template&id=f27dccac&scoped=true&ts=true"
import script from "./BancaOre.vue?vue&type=script&lang=ts"
export * from "./BancaOre.vue?vue&type=script&lang=ts"

import "./BancaOre.vue?vue&type=style&index=0&id=f27dccac&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27dccac"]])

export default __exports__